export function useFreeShipping() {
  const threshold = useState<number>('free-shipping-threshold', () => 0)
  const loaded = useState<boolean>('free-shipping-loaded', () => false)
  const { get } = useApi()

  async function ensureThreshold() {
    if (loaded.value) return
    loaded.value = true
    try {
      const response = await get<{ freeShippingMinOrderAmount: number }>(
        '/shipments/checkout-shipping-policy',
      )
      if (response.success && response.data) {
        threshold.value = Number(response.data.freeShippingMinOrderAmount) || 0
      }
    } catch {
      // keep threshold at 0 (feature simply hidden)
    }
  }

  function progressFor(subtotal: number) {
    const min = threshold.value
    if (!min || min <= 0) {
      return { enabled: false, qualified: false, remaining: 0, percent: 0 }
    }
    const qualified = subtotal >= min
    const remaining = Math.max(0, min - subtotal)
    const percent = Math.min(100, Math.round((subtotal / min) * 100))
    return { enabled: true, qualified, remaining, percent }
  }

  return {
    threshold,
    ensureThreshold,
    progressFor,
  }
}
